import { useSearchParams } from 'react-router-dom';
import useModal from '../../../infrastructure/hooks/useModal';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { app } from '../../../application';
import { EventDTO, GuestEventPost } from '../../../infrastructure/dtos/guest';
import { useForm } from 'react-hook-form';
import { SELECTED_MEDIA } from '../../../infrastructure/dtos/types/file';
import { useImageUploader } from '../../../infrastructure/hooks/useImageUploader';
import { useVideoUploader } from '../../../infrastructure/hooks/useVideoUploader';

export type GuestEventFormType = {
    guestName?: string;
    feeling: string;
    medias?: SELECTED_MEDIA[]
}

export default function useGuestEvent() {
    const formController = useForm<GuestEventFormType>({
        defaultValues: {
            guestName: '',
            feeling: '',
            medias: []
        },
    })
    const [searchParams] = useSearchParams();
    const [savingPost, setSavingPost] = useState(false)
    const eventId = searchParams.get("event");
    const [event, setEvent] = useState<EventDTO['moment'] | null>()
    const justPosted = useModal()
    const imageUploader = useImageUploader();
    const videoUploader = useVideoUploader();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const hasName = useMemo(() => !!app().guestService.guest(eventId as string), [savingPost]);

    useEffect(() => {
        app().guestService.event({event: eventId as string}).then(response => {
            setEvent(response.moment)
        }).catch(err => {
            setEvent(null);
        })
    }, [eventId])

    const onSubmit = useCallback(async (form: GuestEventFormType) => {
        console.log('onSubmit', form)
        setSavingPost(() => true);
        try {
            const moment = searchParams.get("event") ?? '';
            if(!app().guestService.guest(moment)) {
                const guest = await app().guestService.joinGuest(form.guestName ?? '', moment);
                app().guestService.setGuest(guest.user, guest.access_token, moment)
            }

            const medias: GuestEventPost['medias'] = [];
            if(form.medias?.length) {
                for (let mediaIndex = 0; mediaIndex < form.medias.length; mediaIndex++) {
                    const media = form.medias[mediaIndex];
                    if(media.isImage) {
                        const finalMediasResolution = await imageUploader.uploadImage(media.file)
                        medias.push(finalMediasResolution)
                    } else {
                        const finalMediasResolution = await videoUploader.uploadVideo(media.src, media.file)
                        medias.push(finalMediasResolution)
                    }
                }
            }
            // console.log('medias', medias)
            // return null;
            await app().guestService.post({
                moment,
                only_attendees: true,
                content: form.feeling,
                medias: medias
            })

            formController.reset();
            justPosted.toogle();

        } catch (error) {
            console.error('onSubmit error', error)
        }
        finally {
            setSavingPost(() => false);
        }
    },[justPosted, videoUploader, imageUploader, formController, searchParams])

    return {
        justPosted,
        event,
        formController,
        hasName,
        savingPost,
        onSubmit
    }
}
